import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {MemberLoyaltySignupReportModel} from "./member-loyalty-signup-report.model";

@Component({
    selector: "wbo-member-loyalty-signup-report",
    templateUrl: "./member-loyalty-signup-report.component.html",
    providers: [provideReportModel(MemberLoyaltySignupReportModel)]
})
export class MemberLoyaltySignupReportComponent extends AbstractReportPage {
    constructor(public model: MemberLoyaltySignupReportModel) {
        super();
    }
}
